import { render, staticRenderFns } from "./dxal.vue?vue&type=template&id=daae73b2&scoped=true&"
import script from "./dxal.vue?vue&type=script&lang=js&"
export * from "./dxal.vue?vue&type=script&lang=js&"
import style0 from "./dxal.vue?vue&type=style&index=0&id=daae73b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daae73b2",
  null
  
)

export default component.exports